import { TieredMenu } from "primereact/tieredmenu";
import { useCallback, useMemo, useState } from "react";
import { InputGroup } from "react-bootstrap";
import { InputGroupText } from "reactstrap";
import { IconDispatcher } from "shared/Icons";
import { Button, FlexAlignCenter, Input } from "shared/ui-basics";
import styled from "styled-components";
import '../editor.scss';

export const LinkOptions = ({ editor, linkRef, handleshow }) => {
    const previousUrl = useMemo(() => editor.getAttributes('link').href, [editor])

    const isActive = (type, att) => {
        if (att) return editor.isActive(type, att) ? 'is-active' : ''
        return editor.isActive(type) ? 'is-active' : ''
    }

    const Link = useCallback(() => {
        return LinkTemplate({ editor })
    }, [editor])

    const hanldeUnsetLink = (e) => {
        e.preventDefault()
        editor.chain().focus().extendMarkRange('link').unsetLink().run()
    }
    const templates =
        ([{
            template: Link,
        }]);

    return <>
        <TieredMenu model={templates} popup ref={linkRef} breakpoint="767px"  />

        {previousUrl && editor.isActive('link') && <FlexAlignCenter title={previousUrl} className='ellipsis ' style={{ maxWidth: "150px", display: 'block' }}>
            {IconDispatcher('link-simple', "me-2")}{previousUrl}
        </FlexAlignCenter>}
        <button title='Link' onClick={(e) => {
            e.preventDefault()
            handleshow && handleshow(e, 'link')
        }}
            className={previousUrl ? "" : isActive('link')}>
            {IconDispatcher(previousUrl && editor.isActive('link') ? 'edit' : 'link')}
        </button>
        {editor.isActive('link') && <button
            onClick={hanldeUnsetLink}
            disabled={!editor.isActive('link')}>
            {IconDispatcher('link-simple-slash', "me-2 ")}
        </button>}
    </>
}

const LinkTemplate = ({ editor }) => {
    const previousUrl = editor.getAttributes('link').href
    const [url, setUrl] = useState(previousUrl || 'https://');

    const handleSetLink = (e) => {
        e && e.preventDefault();
        if (editor && url) {
            editor.chain().focus().setLink({ href: url, target: '_blank', title: url }).run();
            setUrl('https://'); // Clear the input field after setting the link
        }
    };
    const handleChange = (e) => setUrl(e.target.value)

    return <ContainerLink>
        <FlexAlignCenter>
            <InputGroup>
                <InputGroupText className="bg-white">
                    {IconDispatcher('link-simple', "", { size: "sm" })}
                </InputGroupText>
                <Input
                    variant='default'
                    type="text"
                    value={url}
                    onChange={handleChange}
                    placeholder="'https://cemantica.com"
                    style={{ fontSize: '12px' }}
                />  </InputGroup>
            <Button
                variant='light-outline'
                className='ms-2'
                size='sm'
                onClick={handleSetLink}
                disabled={!url || url === 'https://' || !url.includes('.')}
                style={{ width: 'max-content', fontSize: "14px" }}>
                {previousUrl ? 'Update' : ' Set Link'}
            </Button>

        </FlexAlignCenter>

    </ContainerLink>
}
const ContainerLink = styled.div`
    gap: 0.5em;
    padding: 0.2rem 0.5rem;
    width: 330px;
`